import { ROUTES } from '@/config/routes/paths';
import type { FilterValues } from '@/shared/ui/GeneratikTable';

export const SERVICE_ORDERS_FILTERS_PARAM = 'filters';

export const serviceOrdersFilterLink = (filters: FilterValues): string =>
  `${ROUTES.AUTHORIZED.SERVICE_ORDERS}?${SERVICE_ORDERS_FILTERS_PARAM}=${encodeURIComponent(
    JSON.stringify(filters),
  )}`;

export const parseServiceOrdersFilters = (raw: string | null): FilterValues | null => {
  if (!raw) return null;
  try {
    const parsed: unknown = JSON.parse(raw);
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed)
      ? (parsed as FilterValues)
      : null;
  } catch {
    return null;
  }
};
